import locales_es from './../locales/es';
import Logo from './../images/logo.png';

export const userDataLocalStorage = 'user_data';
export const clinicDataLocalStorage = 'clinic_data';
export const clinicDataExpireDateLocalStorage = 'clinic_data_expire_date';

export const APPOINTMENT_PRESENTIAL_TYPE = 1;
export const APPOINTMENT_VIRTUAL_TYPE = 2;
export const APPOINTMENT_MIXED_TYPE = 3;
// TIMEZONE
export const DEFAULT_TIME_ZONE = 'America/Argentina/Buenos_Aires';
export const DEFAULT_SLUGNAME = 'not_configured';

export const IMAGE_LOGO = Logo;

// STORAGE & USER CONSTANTS
export const userAccessToken = 'token';

// CLINIC TODO
// export const CLINIC_ID = process.env.REACT_APP_CLINIC_ID;

// Days of the week
export const DAYS_OF_THE_WEEK = [
    {
        value: 1,
        name: locales_es.daysOfTheWeek.monday,
    },
    {
        value: 2,
        name: locales_es.daysOfTheWeek.tuesday,
    },
    {
        value: 3,
        name: locales_es.daysOfTheWeek.wednesday,
    },
    {
        value: 4,
        name: locales_es.daysOfTheWeek.thursday,
    },
    {
        value: 5,
        name: locales_es.daysOfTheWeek.friday,
    },
    {
        value: 6,
        name: locales_es.daysOfTheWeek.saturday,
    },
    {
        value: 0,
        name: locales_es.daysOfTheWeek.sunday,
    },
];

// HREF
export const HREF_PAGE_HOME = '/';
export const HREF_PAGE_APPOINTMENT_REVIEW = '/appointment-review';
export const HREF_PAGE_MEDIC_ADD_TIMETABLE = '/medic-add-timetable';
export const HREF_PAGE_MEDIC_EDIT_TIMETABLES = '/medic-timetables';
export const HREF_PAGE_MEDIC_EDIT_NON_WORKING_DAYS = '/nonWorking-days';
export const HREF_PAGE_DASHBOARD = '/dashboard';
export const hrefLogin = '/login';
export const HREF_REGISTER = '/register';
export const HREF_REGISTER_PATIENT = '/register-patient';
export const HREF_REGISTER_MEDIC = '/register-medic';
export const hrefRecovery = '/recovery';
export const hrefDashboard = '/dashboard';
export const HREF_PAGE_CHANGE_PASSWORD = '/change-password';
export const HREF_PAGE_ADD_MEDICAL_INSURANCE = '/add-medical-insurance';
export const HREF_PAGE_ADD_MEDICAL_INSURANCE_PATIENT = '/add-medical-insurance-patient';
export const HREF_PAGE_MY_PROFILE = '/my-profile';
export const HREF_PAGE_MY_MEDIC_PROFILE = '/my-medic-profile';
export const HREF_PAGE_MEDIC = '/medic';
export const HREF_PAGE_MEDICS = '/medics';
export const HREF_PAGE_MY_MEDICS = '/my-medics';
export const HREF_PAGE_MY_INSURANCES = '/my-insurances';
export const HREF_PAGE_ONLINE = '/online';
export const HREF_PAGE_VIDEOCALL = '/videocall';
export const HREF_PAGE_ADD_MEDIC = '/add-medic';
export const HREF_PAGE_ADD_CLINIC = '/add-clinic';
export const HREF_PAGE_ADD_PATIENT = '/add-patient';
export const HREF_PAGE_TERMS = '/terms';
export const HREF_PAGE_PATIENTS = '/patients';
export const HREF_PAGE_PRESCRIPTIONS = '/recetas';
export const HREF_PAGE_ADD_PRESCRIPTION = '/nueva-receta';
export const HREF_PAGE_CERTIFICATES = '/otras-prescripciones';
export const HREF_PAGE_ADD_CERTIFICATE = '/nueva-prescripcion';
export const HREF_PAGE_DOCUMENT_VISOR = '/visor-de-documentos';
export const HREF_PAGE_ADD_PROFESSIONAL_REGISTRATION = '/agregar-matricula';
export const HREF_PAGE_ADD_PRESCRIPTION_PROFILE = '/agregar-perfil-de-receta';
export const HREF_PAGE_PATIENT = '/paciente';
export const HREF_PAGE_PATIENT_INSURANCES = '/coberturas-medicas';
export const HREF_PAGE_SETTINGS = '/settings';
export const HREF_PAGE_CLINIC_SETTINGS = '/configuracion-clinica';

// EMAIL REMINDER STATUS
export const EMAIL_REMINDER_STATUS_PENDING = 'pending';
export const EMAIL_REMINDER_STATUS_SENT = 'sent';
export const EMAIL_REMINDER_STATUS_OPENED = 'opened';
export const EMAIL_REMINDER_STATUS_FAIL = 'fail';
export const EMAIL_REMINDER_STATUS_FAILED = 'failed';

// parseTelInput
export const PARSE_TEL_INPUT_ONLY_COUNTRIES = ['AR', 'BR', 'CL', 'CO', 'CU', 'EC', 'ES', 'IL', 'IT', 'MX', 'PE', 'PY', 'UY', 'VE'];
export const PARSE_TEL_INPUT_COUNTRIES_CODES = [
    {
        countryCode: 'ar',
        dialCode: '+54'
    },
    {
        countryCode: 'br',
        dialCode: '+55'
    },
    {
        countryCode: 'cu',
        dialCode: '+53'
    },
    {
        countryCode: 'ec',
        dialCode: '+593'
    },
    {
        countryCode: 'es',
        dialCode: '+34'
    },
    {
        countryCode: 'it',
        dialCode: '+39'
    },
    {
        countryCode: 'mx',
        dialCode: '+52'
    },
    {
        countryCode: 'uy',
        dialCode: '+598'
    },
    {
        countryCode: 'cl',
        dialCode: '+56'
    },
    {
        countryCode: 'py',
        dialCode: '+592'
    },
    {
        countryCode: 'co',
        dialCode: '+57'
    },
    {
        countryCode: 've',
        dialCode: '+58'
    },
    {
        countryCode: 'pe',
        dialCode: '+51'
    }
];

// API ERROR CODES
export const emailExists = 'email_exists';

// Payment Gateway ID's
export const PAYMENT_METHOD_BANK_TRANSFER_ARS = 'bank_transfer_ars';
export const PAYMENT_METHOD_MERCADO_PAGO_ARS = 'mercado_pago_ars';
export const PAYMENT_METHOD_PAYPAL_USD = 'paypal_usd';
export const PAYMENT_METHOD_BANK_TRANSFER_USD = 'bank_transfer_usd';
export const PAYMENT_METHOD_MANUAL_ARS = 'manual_ars';
export const PAYMENT_METHOD_MANUAL_USD = 'manual_usd';
export const CURRENCY_ID_USD = 'USD';
export const CURRENCY_ID_ARS = 'ARS';
export const STATUS_SUCCESS = 'success';
export const STATUS_FAILED = 'failed';

export const PAYMENT_STATUS_PENDING = 'pending';
export const PAYMENT_METHOD_AMOUNT_TYPE_PERCENT = 'percent';
export const PAYMENT_METHOD_AMOUNT_TYPE_FIXED = 'fixed';
export const MERCADO_PAGO_BASIC = 'mercadopago_basic';
export const STRIPE = 'stripe';

// USER TYPES
export const USER_TYPE_PATIENT = 'patient';
export const USER_TYPE_MEDIC = 'medic';
export const USER_TYPE_SECRETARY = 'secretary';

// APPOINTMENT TYPES
export const APPOINTMENT_STATUS_FREE = 'free';
export const APPOINTMENT_STATUS_OCCUPIED = 'occupied';

export const APPOINTMENT_PAYMENT_STATUS_NOT_APPLY = 'not_apply';

// FULLCALENDAR
// export const FC_SLOT_MIN_TIME = "06:00";
// export const FC_SLOT_MAX_TIME = "23:00";
export const FC_SLOT_MIN_TIME = "08:00";
export const FC_SLOT_MAX_TIME = "21:00";


// SCRIPTS IDS
export const stripeScriptId = 'stripe-library-script';

// HEADER
export const headerNavId = 'headerNav';
export const headerNavLogoutLinkId = 'headerNavLogoutLink';
export const headerNavWrapperId = 'headerNavWrapper';
export const setNavLinksEvent = 'setNavLinks';
export const EVENT_PROFILE_UPDATE = 'eventProfileUpdate';
export const setHiddenHeaderEvent = 'setHiddenHeader';



export const STATUS_COLORS = {
    "appointmentBadges" : {
        "scheduled": "kt-badge--primary",
        "pending": "kt-badge--primary",
        "confirmed": "kt-badge--success",
        "waiting_room": "kt-badge--accent",
        "attending": "kt-badge--focus",
        "completed": "kt-badge--dark",
        "patient_missed": "kt-badge--danger",
        "patient_canceled": "kt-badge--metal",
        "medic_canceled": "kt-badge--metal",
    },
    "appointmentButton" : {
        "scheduled": "btn-primary",
        "pending": "btn-primary",
        "confirmed": "btn-success",
        "waiting_room": "btn-accent",
        "attending": "btn-focus",
        "completed": "btn-dark",
        "patient_missed": "btn-danger",
        "patient_canceled": "btn-metal",
        "medic_canceled": "btn-metal",
    },
    "paymentStatusButton" : {
        "not_aply": "btn-metal",
        "not_apply": "btn-metal",
        "pending": "btn-danger",
        "paid": "btn-success",
    },
    "paymentStatusBadges" : {
        "not_aply": "kt-badge--metal",
        "not_apply": "kt-badge--metal",
        "pending": "kt-badge--danger",
        "paid": "kt-badge--success",
    },
    "paymentStatusFancyDotSpinner": {
        "not_aply": "text-metal",
        "not_apply": "text-metal",
        "pending": "text-danger",
        "paid": "text-success",
    },
    "fancyDotSpinner" : {
        "scheduled": "text-primary",
        "pending": "text-primary",
        "confirmed": "text-success",
        "waiting_room": "text-accent",
        "attending": "text-focus",
        "completed": "text-dark",
        "patient_missed": "text-danger",
        "patient_canceled": "text-metal",
        "medic_canceled": "text-metal",
    },
    "calendarDot" : {
        "scheduled": "dot-primary",
        "pending": "dot-primary",
        "confirmed": "dot-success",
        "waiting_room": "dot-accent",
        "attending": "dot-focus",
        "completed": "dot-dark",
        "patient_missed": "dot-danger",
        "patient_canceled": "dot-metal",
        "medic_canceled": "dot-metal",
    }
};

export const MED_ICON_BASE_64 = "data:image/png;base64,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";

// PRESCRIPTIONS REQUESTS ERROR CASES
export const PRESCRIPTION_ERROR_INVALID_CREDENTIAL = 'invalid_credential';

export const MEDICAL_PRESCRIPTION_TYPE = 'Prescription';
export const PRESCRIPTION_CERTIFICATE_TYPE = 'Certificate';

export const USER_FIELDS = ['email', 'cellphone', 'identification_type_id', 'identification', 'date_of_birth', 'gender_id', 'time_zone'];
